// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"2e71d666","55":"78dd8111","77":"b0454479","126":"d454bc31","171":"d9bd64ce","382":"7f0469b9","456":"4228a420"}[chunkId] + ".chunk.js";
};